class PlotArea extends React.Component {
  componentDidMount() {
    this.plot();
  }

  componentDidUpdate() {
    this.plot();
  }

  plot() {
    let {
      data,
      scaleX,
      scaleY,
      getX,
      getY,
      color,
      opacity,
      shape
    } = this.props;

    let pairY = (d) => [0].concat(getY(d)).slice(-2);

    let areaGenerator = d3.area()
      .defined((d) => d !== undefined)
      .x((d, i) => scaleX(getX(d, i)))
      .y0((d) => scaleY(pairY(d)[0]))
      .y1((d) => scaleY(pairY(d)[1]));

    if (shape === "curve") {
      areaGenerator.curve(d3.curveCardinal);
    }

    d3.select(this.refs.area)
      .datum(data)
      .attr("d", areaGenerator)
      .attr("fill", color)
      .attr("fill-opacity", opacity);
  }

  render() {
    return (
      <g className="mc-plot-area">
        <path ref="area"/>
      </g>
    );
  }
}

PlotArea.defaultProps = {
  color: "#304561",
  opacity: 1,
  shape: "straight" // "curve"
};

module.exports = PlotArea;
